export const NOTHS_REFERER_REGEX = /^(.*notonthehighstreet.*|.*noths.*)/;
export const CART_PATH = '/cart';
